module.exports = __webpack_public_path__ + "img/accreditation.c6754a66.svg";